"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderProfile = void 0;
var provider_profile_1 = require("./provider-profile");
Object.defineProperty(exports, "ProviderProfile", { enumerable: true, get: function () { return __importDefault(provider_profile_1).default; } });
//# sourceMappingURL=index.js.map